<nav class="settings-sidebar-container">
  @for (item of items; track item.id) {
    <button
      type="button"
      class="settings-sidebar-item"
      [attr.data-testid]="'settings-sidebar-item-' + item.id"
      [class.active]="activeTab() === item.id"
      (click)="onItemClick(item.id)"
      *hasPermissionGroups="item.permissionGroups"
    >
      <app-icon [src]="item.icon" [alt]="item.labelKey | translate" class="w-4 h-4 shrink-0" />
      <span>{{ item.labelKey | translate }}</span>
    </button>
  }
</nav>
